module.exports = __webpack_public_path__ + "static/media/molhos.fc1e0e3a.png";